import { render } from "./GenerateProposal.vue?vue&type=template&id=68407ae0"
import script from "./GenerateProposal.vue?vue&type=script&lang=js"
export * from "./GenerateProposal.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__